const ActionType = {
  View: "view",
  Click: "click",
  Impression: "imp"
};

export { ActionType };
//# sourceMappingURL=index.mjs.map
